import { memo, useMemo } from "react";
import { allProductsDatum, flattenProductMetadataForDropdown } from "@atlas-int/data";
import { useProductsMetadata } from "../../../hooks/useMetadata";
import { useExploreParams } from "../../../visualization/paramSchemas";
import { DropdownSkeleton } from "@atlas-int/ui";
import { ProductDropdown as ProductDropdownBase } from "@atlas-int/controls";
import { ProductClass } from "@atlas-int/data/types";
import type { ProductMetadataByLevel } from "@atlas-int/data/types";

const ProductDropdown = ({ productClass, metadata }: { productClass: ProductClass; metadata: ProductMetadataByLevel }) => {
  const [{ product }, setQuery] = useExploreParams();

  const productClassShortLabel = productClass as string;

  const flatProducts = useMemo(() => {
    if (!metadata) return [];
    return flattenProductMetadataForDropdown(metadata);
  }, [metadata]);

  const handleSelect = (productId: string) => {
    setQuery({ product: productId });
  };

  if (!metadata || flatProducts.length === 0) {
    return <DropdownSkeleton />;
  }

  return (
    <ProductDropdownBase
      products={flatProducts}
      value={product}
      onChange={handleSelect}
      productClassLabel={productClassShortLabel}
      allProductsId={allProductsDatum.productId}
    />
  );
};

const ProductDropdownWrapper = () => {
  const [{ productClass }] = useExploreParams();
  const productsState = useProductsMetadata(productClass);

  if (productsState.status === "loading") {
    return <DropdownSkeleton />;
  }

  if (productsState.status === "error" || productsState.status === "idle") {
    return <DropdownSkeleton />;
  }

  return (
    <ProductDropdown metadata={productsState.data} productClass={productClass} />
  );
};

export default memo(ProductDropdownWrapper);
